import React from 'react';
import {Link, withRouter} from 'react-router-dom';
import PropTypes from 'prop-types';
import classNames from 'classnames';

/* Atoms (baseline) */
import {Avatar, Unveil} from '../../atoms/baseline/baseline';

/* Atoms (custom) */
import {DateContent} from '../../atoms/DateContent/DateContent';

/* Molecules (custom) */
import {MessagesCard} from '../MessagesCard/MessagesCard';

/* Utils */
import '../../../utils/closest';
import {inboxMessageSelected, INBOX} from '../../../utils/edapUtils';
import translate from '../../../utils/translations';

import './InboxConversation.less';

export const InboxConversation = (props) => {
    const {
        conversationID,
        correspondents: [{avatar, name}] = [{}],
        displayCurrentState,
        displayLastMessageDate = '',
        displayLocation,
        displayStayDates,
        messageText,
        totalGuests,
        translations = {},
        unreadMessages = false,
        isVrbexNative = false,
        history = {},
    } = props;

    const handleConversationClick = () => {
        inboxMessageSelected({actionLocation: INBOX});
    };

    const classes = classNames('InboxConversation', {
        'InboxConversation--unread': unreadMessages,
    });
    const numberOfGuests = translate(
        translations,
        'trav-dash/trav-home',
        'messages',
        'th.inbox.conversation.guests',
        {GUESTS: totalGuests}
    );

    let messagesUrl = `/traveler/th/inbox/conversation/${conversationID}/messages`;
    if (isVrbexNative && history.location?.search) {
        messagesUrl += history.location.search;
    }

    return (
        <Link
            className={classes}
            data-testid="link"
            onClick={handleConversationClick}
            to={messagesUrl}
        >
            <div className="InboxConversation__avatar" data-testid="avatar">
                <Unveil>
                    <Avatar
                        dataObject={{
                            firstName: '',
                            lastName: '',
                            publicImageUrl: avatar,
                        }}
                        hasTooltip={false}
                        size="64"
                    />
                </Unveil>
            </div>
            <MessagesCard
                currentState={displayCurrentState}
                data-testid="MessagesCard"
                lastMessageDate={displayLastMessageDate}
                location={displayLocation}
                messageText={messageText}
                name={name}
                numberOfGuests={numberOfGuests}
                stayDates={displayStayDates}
                totalGuests={totalGuests}
                unreadMessages={unreadMessages}
            />
            <DateContent
                isMobile={false}
                lastMessageDate={displayLastMessageDate}
                unreadMessages={unreadMessages}
            />
        </Link>
    );
};

InboxConversation.propTypes = {
    conversationID: PropTypes.string.isRequired,
    correspondents: PropTypes.arrayOf(
        PropTypes.shape({
            avatar: PropTypes.string.isRequired,
            name: PropTypes.string.isRequired,
        })
    ).isRequired,
    displayCurrentState: PropTypes.string.isRequired,
    displayLastMessageDate: PropTypes.string,
    displayLocation: PropTypes.string.isRequired,
    displayStayDates: PropTypes.string.isRequired,
    isVrbexNative: PropTypes.bool,
    messageText: PropTypes.string,
    totalGuests: PropTypes.number,
    translations: PropTypes.shape({}),
    unreadMessages: PropTypes.bool,
};

export default withRouter(InboxConversation);
